(function ($) {
    function addOverlayClass(){
        $("section.promo-block").each(function() {
            var subscribeBtns = $(this).find(".btn-wrapper a");
            subscribeBtns.each(function() {
                if ($(this).text() === "Subscribe") {
                    $(this).addClass("formOverlay");
                    $(this).attr("href", "#");
                }
            });
        });
    }

    function videoOverlay() {
        $(document).on("click", ".formOverlay", function (e) {
            e.preventDefault();
            $(".form-overlay").addClass("overlay-active");
           $(this).parents('body').find('#formWrapper').clone().appendTo(".form-overlay .mailChimp-form");
           let classes = $(e.target).attr("class"); 
           if (classes) {
            let matchedClass = classes.split(" ").find(cls => cls.includes("manipulate-"));
            if (matchedClass) {
                $('.form-overlay .hbspt-form-wrap').each(function(){
                    $(this).addClass('hide');
                }); 
                $('.'+matchedClass).removeClass('hide');
                $('.'+matchedClass).addClass('show');
            } else {
                $('.hbspt-form-wrap').eq(0).removeClass('hide');
            }
           }

        });
        closeVideoOverlay();
    }

    function videoOverlayUrlHandler() {
        
        let hashParam = window.location.hash;
        if(hashParam){
            if((hashParam == "#subscribe") && (window.location.pathname == "/publications/uncommon-knowledge")){
                var interval = setInterval(function() {
                    if ($(".form-overlay").length > 0) {
                        clearInterval(interval); 
                        $(".form-overlay").addClass("overlay-active");
                        $('body').find('#formWrapper').clone().appendTo(".form-overlay .mailChimp-form");
                    }
                }, 100);
            }
        }
        
        closeVideoOverlay();
    }

    // Close video overlay on outside/close-btn click
    // function closeVideoOverlay() {
    //     // Close video overlay on close button & outside click
    //     $(document).on("click", ".form-close", function () {
    //         $(".form-overlay").removeClass("overlay-active");
    //         $(".form-overlay").find("iframe").attr("src", "");
    //     });
    //     $(document).on("click", ".form-overlay", function () {
    //         $(".form-overlay").removeClass("overlay-active");
    //         $(".form-overlay").find("iframe").attr("src", "");
    //     });
    //     // Prevent closing on video's click
    //     $(".form-overlay  iframe").on("click", function (e) {
    //         e.stopPropagation();
    //     });
    // }

    // Close form overlay on outside/close-btn click
    function closeVideoOverlay() {
        // Close form overlay on close button & outside click
        $(document).on("click", ".form-close", function () {
            $(".form-overlay").find(".mailChimp-form #formWrapper").remove();
            $(".form-overlay").removeClass("overlay-active");
            $(".mailchimp-signup-subscribe-form").css({ 'display': 'none' });
            $('.form-overlay .hbspt-form-wrap').each(function(){
                $(this).addClass('hide');
            }); 
        });
        $(document).on("click", ".form-overlay", function () {
            $(".form-overlay").find(".mailChimp-form #formWrapper").remove();
            $(".form-overlay").removeClass("overlay-active");
            $(".mailchimp-signup-subscribe-form").css({ 'display': 'none' });
            $('.form-overlay .hbspt-form-wrap').each(function(){
                $(this).addClass('hide');
            }); 
        });
        // Prevent closing on form's click
        $(document).on("click", ".form-overlay .mailChimp-form form", function (e) {
            e.stopPropagation();
        });
    }


    $(document).ready(function () {
        if(window.location.pathname == "/publications/uncommon-knowledge"){
            addOverlayClass()
        }
        videoOverlay();
        video_height();
        setTimeout(()=>{
            videoOverlayUrlHandler();
         },1500)
    });

    $(window).on("load scroll resize", function () {
        video_height();
    });

    function video_height() {
        var windowheight = $(window).height() / 1.9,
            windowWidth = $(window).width() / 1.2;
        $(".form-overlay iframe").attr("width", windowWidth + "px");
        $(".form-overlay iframe").attr("height", windowheight + "px");
    }


    // $(document).on("click", "a.open-overlay", function (e) {
    //     e.preventDefault();
    //     $(".form-overlay").addClass("overlay-active");
    //     $(".mailchimp-signup-subscribe-form").css({ 'display': 'block' });
    //
    // });

})(jQuery);
